module.exports = __webpack_public_path__ + "img/back.0ce6c11e.jpg";